import Shimmer from "src/components/Shimmer";
import useSearchModalDim from "./hooks/useSearchModalDim";

const SearchModalSkeleton = () => {
	const modalDim = useSearchModalDim();

	return <Shimmer colorVariant="Modal" style={modalDim} />;
};
export default SearchModalSkeleton;
